import {Entity} from '../core/main.entity';

export class Carrier extends Entity {
  id: number;
  title: string;
}
